import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants"

export const HeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        nested: { key: "name" },
    },
    {
        id: 'organization',
        label: 'Organization',
        type: 'text',
        nested: { key: "organizationName", },
    },
    {
        id: 'quantity',
        label: 'Members count',
        nested: { key: "quantity", },
        style: { textAlign: "center" },
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];
export const DataFields = [
    'name',
    "organization",
    "quantity",
    "actions"
];

export const UsersHeadCells = [
    {
        id: 'name',
        label: 'Name',
        type: 'text',
        isDecrypted: true,
        nested: { key: "name"  },
    },
    {
        id: 'type',
        label: 'Type',
        type: 'text',
        isDecrypted: true,
        nested: { key: "type" },
    },
    {
        id: 'organization',
        label: 'Organization',
        type: 'text',
        style: { textAlign: "center" },
        nested: { key: "organization"},
    },
    {
        id: 'active',
        label: 'Is Inactive',
        type: 'boolean', 
        nested: { key: "inactive"},
    },
    {
        id: 'actions',
        label: 'Actions',
        type: 'text',
        style: { textAlign: "center" },
    },
];

export const UsersDataFields = [
    'name',
    'phone',
    'organization',
    'active',
    'actions'
];
export const typeOptions = [
    { value: "Patient", name: "Patient" }, 
    { value: "Practitioner", name: "Practitioner" },
]

export const FormikObj = {
    initialValues: {
        member: [],
        orgId: "",
        name: "",
        description: "",
        quantity: 0,
        type: "",
    },
    validationSchema: Yup.object({
        member: Yup.array().min(1, "At least one member is required"),
        orgId: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
            {
                validation,
                label: "Organization",
                mandatory: true
            }),
        name: conditionalValidation(
            Yup.string().max(1000, "Must be 1000 characters or less").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
                        {
                validation,
                label: "Name",
                mandatory: true
            }),
        description: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Description"
            }),
        type: conditionalValidation( 
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                mandatory: true,
                label: "Type"
            })
    }),
}